import React, { useState, useEffect } from 'react';
import i18n from 'i18n-js';
import { methods } from 'constants/payments';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError, generateFilterOptions } from 'utils';

const PaymentMethodSelect = ({
  label,
  variant,
  field: { name, value },
  form: { errors, touched, setFieldValue },
  omitFields = [],
  asyncErrors,
  margin,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [defaultValue, setDefaultValue] = useState(null);
  const filterOptions = generateFilterOptions('start', 'label');
  useEffect(() => {
    if (value || value === '') {
      const defaultVal = methods.find((method) => method === value);
      if (defaultVal) {
        setDefaultValue(i18n.t(`payment_methods.${defaultVal}`));
      } else {
        setDefaultValue(null);
      }
    }
  }, [value, methods]); // eslint-disable-line

  return (
    <Autocomplete
      openOnFocus
      label={label}
      margin={margin}
      variant={variant}
      id="payment-methods"
      inputValue={inputValue}
      defaultValue={defaultValue}
      filterOptions={filterOptions}
      onInputChange={(ev, val) => setInputValue(val || '')}
      onChange={(ev, val) => setFieldValue(name, val || '')}
      error={handleError(name, errors, touched, asyncErrors)}
      options={methods.filter((value) => omitFields.indexOf(value))}
      helperText={handleShowError(name, errors, touched, asyncErrors)}
      getOptionLabel={(option) =>
        i18n.t(`payment_methods.${option}`, { defaultValue: option?.label || option })
      }
      getOptionSelected={(option, value) =>
        i18n.t(`payment_methods.${option}`, { defaultValue: option?.label || option }) === value ||
        ''
      }
    />
  );
};

export default PaymentMethodSelect;
